export default {
  errorTitle: 'Error',
  required: 'Required field',
  email: 'Invalid e-mail',
  date: 'Invalid date format',
  number: 'We accept only numbers',
  float: 'Valid characters 0-9, \'.\'',
  min: 'Min',
  max: 'Max',
  symbol1: 'symbol',
  symbol2: 'symbols',
  symbol3: 'symbols',
  fio: 'Valid characters А-Я, \'-\'',
  ruEnString: 'Valid characters А-Я, A-Z, \'-\'',
  ruDotString: 'Valid characters А-Я, \'-\', \'.\'',
  numberRuString: 'Valid characters А-Я, 0-9, \'-\', \'.\'',
  address: 'Valid characters А-Я, 0-9, \'/\', \'-\', \'.\', \'(\', \')\'',
  phone: 'Invalid phone number',
  inn: 'Invalid INN',
  year: 'Invalid year',
  snils: 'Invalid SNILS',
  firstUpperCase: 'Fill in with a capital letter',
  agree: 'You must give your consent to the processing of personal data',
  age: 'You should be more',
  year1: 'year',
  year2: 'year',
  noSpaceSymbol: 'The space character is not allowed',
  url: 'Enter url'
}
